module.exports = __webpack_public_path__ + "static/media/21.92e3af36.png";